import TreeNode from '../../containers/TcinInfo/TreeNode'
import {
  GET_TCIN_INFO_DATA,
  SORTED_TCIN_INFO_DATA,
  ENLARGE_IMAGE,
  SET_FILTER_DATA,
  GROUPING_TREE_DATA,
  SELECTED_TCIN_DATA,
  SELECTED_FILTER_TCINS,
  DATA_FILTERED,
  TREE_LIST_DATA,
  USER_FILTERS,
  SET_SHOW_CONTENT,
  SET_MAX_ALT_IMAGE_COUNT,
  SET_ERROR_TYPE,
  SET_ERROR_LIST,
  SET_LAYOUT,
  SET_COLUMN_MAP,
  SET_TEMP_COLUMN_MAP,
  SET_USER_COL_MAP,
  SET_CUSTOMIZED_VIEW,
  SET_APPLIED_VIEW,
  SET_IS_APPLY_DISABLED,
  SET_IS_SAVE_DISABLED,
  SET_TEMP_LAYOUT,
} from './actionTypes'
import {
  columnMap,
  altImageData,
  altSourceImageData,
} from '../../containers/TcinInfo/constants'

const initialState = {
  filters: {},
  filteredTCINS: [],
  dataFiltered: [],
  userFilters: {},
  selected: [],
  treeList: [],
  maxAltImageCount: 0,
  showContent: 'blank',
  errorType: 'none',
  errorsList: [],
  columnMap: columnMap,
  tempColMap: columnMap,
  userColMap: [],
  customizeView: null,
  appliedView: null,
  layout: 'flat',
  isApplyDisabled: true,
  isSaveDisabled: true,
  tempLayout: 'flat',
  tree: {
    treeNode: new TreeNode('root'),
    treeMap: new Map(),
  },
  enlargeImage: {
    open: false,
    title: '',
    src: '',
    fileName: '',
  },
}

export default function tcinPhotoInfo(state = initialState, action) {
  switch (action.type) {
    case GET_TCIN_INFO_DATA:
      return {
        ...state,
        tcinPhotoData: action.payload,
      }

    case SET_LAYOUT:
      return {
        ...state,
        layout: action.payload,
      }

    case SET_TEMP_LAYOUT:
      return {
        ...state,
        tempLayout: action.payload,
      }

    case SET_COLUMN_MAP:
      return {
        ...state,
        columnMap: action.payload,
      }

    case SET_TEMP_COLUMN_MAP:
      return {
        ...state,
        tempColMap: action.payload,
      }

    case SET_USER_COL_MAP:
      return {
        ...state,
        userColMap: action.payload,
      }

    case SET_CUSTOMIZED_VIEW:
      return {
        ...state,
        customizeView: action.payload,
      }

    case SET_APPLIED_VIEW:
      return {
        ...state,
        appliedView: action.payload,
      }

    case SET_IS_APPLY_DISABLED:
      return {
        ...state,
        isApplyDisabled: action.payload,
      }

    case SET_IS_SAVE_DISABLED:
      return {
        ...state,
        isSaveDisabled: action.payload,
      }

    case SET_SHOW_CONTENT:
      return {
        ...state,
        showContent: action.payload,
      }

    case SET_ERROR_TYPE:
      return {
        ...state,
        errorType: action.payload,
      }

    case SET_ERROR_LIST:
      return {
        ...state,
        errorsList: action.payload,
      }

    case SET_MAX_ALT_IMAGE_COUNT:
      return {
        ...state,
        maxAltImageCount: action.payload,
      }

    case SORTED_TCIN_INFO_DATA:
      return {
        ...state,
        sortedTcinPhotoData: action.payload,
      }

    case ENLARGE_IMAGE:
      return {
        ...state,
        enlargeImage: { ...action.payload },
      }

    case SET_FILTER_DATA:
      return {
        ...state,
        filters: action.payload,
      }

    case GROUPING_TREE_DATA:
      return {
        ...state,
        tree: action.payload,
      }

    case TREE_LIST_DATA:
      return {
        ...state,
        treeList: action.payload,
      }

    case SELECTED_TCIN_DATA:
      return {
        ...state,
        selected: action.payload,
      }

    case SELECTED_FILTER_TCINS:
      return {
        ...state,
        filteredTCINS: action.payload,
      }

    case DATA_FILTERED:
      return {
        ...state,
        dataFiltered: action.payload,
      }
    case USER_FILTERS:
      return {
        ...state,
        userFilters: action.payload,
      }
    default:
      return state
  }
}
